// High-quality fallback data to ensure the site looks finished even before DB is fully seeded
export const mockProducts = [
  {
    id: '1',
    title: 'Start AI Right for Nonprofits',
    slug: 'start-ai-right-ebook',
    product_type: 'E-book',
    short_description: 'A practical guide for mission-led leaders to move from informal AI use to clear organisational oversight and safer boundaries.',
    price_pence: 999,
    is_free: false,
    stripe_price_id: import.meta.env.VITE_EBOOK_PRICE_ID || 'price_placeholder_ebook',
    cover_image_url: 'https://media-manager-c.questera.ai/greta-media/7c98abf852f963e06195176deed57bb9c81b4f53d205af5ca5b2f9af1b9cfaa840d35f6737e086b8644a3796bedcf0cc/images/aW1hZ2UvcG5n/0544aa9080d7a1bd34f91fb6b907bd13.png',
    is_active: true
  },
  {
    id: '2',
    title: 'The Responsible Leader’s Guide',
    slug: 'responsible-leaders-guide',
    product_type: 'Guide',
    short_description: 'A free framework for nonprofit and cultural leaders to navigate AI with confidence and protect community trust.',
    price_pence: 0,
    is_free: true,
    stripe_price_id: null,
    cover_image_url: 'https://media-manager-c.questera.ai/greta-media/7c98abf852f963e06195176deed57bb9c81b4f53d205af5ca5b2f9af1b9cfaa840d35f6737e086b8644a3796bedcf0cc/images/aW1hZ2UvanBlZw==/a57c13e228f36e7ced2b38158dae4ce1.jpg',
    is_active: true
  },
  {
    id: '3',
    title: 'Responsible AI Prompt Pack',
    slug: 'responsible-ai-prompt-pack',
    product_type: 'Prompt Pack',
    short_description: 'Pre-tested, safe prompts designed specifically for charity and nonprofit workflows including grant writing and reporting.',
    price_pence: 2500,
    is_free: false,
    stripe_price_id: import.meta.env.VITE_PROMPT_PACK_PRICE_ID || 'price_placeholder_pack',
    cover_image_url: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&q=80&w=800',
    is_active: true
  }
];

export const mockResources = [
  {
    id: '1',
    title: 'Part 1 - S is for Secure: Why Trust Is the First Layer of Ethical AI',
    slug: 's-is-for-secure-trust-ethical-ai',
    category: 'AI Governance',
    excerpt: 'Security inside a nonprofit is far more human than technical. It is about protecting the people, donors, and communities.',
    content: `When people hear “AI security,” their minds go straight to data breaches, hackers, or compliance checklists. But inside a nonprofit, security is far more human. It’s about protecting the people behind the data, the donors who trust you, the communities who share their stories, the staff who carry the mission forward. Security isn’t just a technical layer. It’s a moral one.`,
    created_at: '2025-10-20T09:00:00Z'
  },
  {
    id: '2',
    title: 'Part 2 - A is for Accountable: Why Clear Oversight Is the New Credibility',
    slug: 'a-is-for-accountable-oversight-credibility',
    category: 'AI Governance',
    excerpt: 'Accountability today is more than governance, it’s a public signal of integrity and taking ownership of AI outcomes.',
    content: `When it comes to AI, most mission-driven organisations worry about what the technology can do. Fewer stop to ask who is responsible for what it does. That’s the real leadership gap.`,
    created_at: '2025-10-27T09:00:00Z'
  },
  {
    id: '3',
    title: 'Part 3 - F is for Future-Ready: From Catch-Up to Catalyst',
    slug: 'f-is-for-future-ready-readiness',
    category: 'AI Governance',
    excerpt: 'Being future-ready is not about chasing every new AI tool. It is about building the capacity to adapt without compromising purpose.',
    content: `Future-readiness is not about predicting the next tool. It is about putting foundations in place that allow your organisation to respond thoughtfully as change unfolds.`,
    created_at: '2025-12-15T09:00:00Z'
  },
  {
    id: '4',
    title: 'Part 4 — F is for Future-Ready: From Catch-Up to Catalyst',
    slug: 'f-is-for-future-ready-innovation',
    category: 'AI Governance',
    excerpt: 'Future-readiness is where policy stops being a brake and starts becoming an enabler for responsible innovation.',
    content: `In the SAFE AI™ Framework, Future-Ready does not sit on the defensive side of governance. It is about creating the conditions where responsible innovation can happen safely.`,
    created_at: '2026-01-09T09:00:00Z'
  },
  {
    id: '5',
    title: 'Part 5 — E is for Empowered: Preparing People, Not Just Systems, for the AI Era',
    slug: 'e-is-for-empowered-preparing-people',
    category: 'AI Governance',
    excerpt: 'AI strategies succeed because people feel capable, confident, and supported. Empowerment is about building human capability.',
    content: `AI strategies do not succeed because organisations adopt the right tools. They succeed because people feel capable, confident, and supported enough to use them well.`,
    created_at: '2026-01-22T09:00:00Z'
  },
  {
    id: '6',
    title: 'Part 6 — A is for Aligned: Ensuring AI Serves Your Mission, Not the Other Way Around',
    slug: 'a-is-for-aligned-mission-alignment',
    category: 'AI Governance',
    excerpt: 'AI does not arrive neutral. Alignment is about ensuring AI actively supports your organisation’s mission.',
    content: `Inside the SAFE AI™ Framework, Aligned is about ensuring AI actively supports your organisation’s mission, vision, and strategy, rather than quietly reshaping them.`,
    created_at: '2026-02-06T09:00:00Z'
  },
  {
    id: '7',
    title: 'Part 7 — I is for Inclusive: Ensuring AI Does Not Leave People Behind',
    slug: 'i-is-for-inclusive-equity-and-access',
    category: 'AI Governance',
    excerpt: 'AI systems reflect the data they are built on. Inclusion ensures AI does not exclude, misrepresent, or disadvantage the communities you serve.',
    content: `AI systems are built on data. Data reflects history. History reflects power. That is why inclusion cannot be an afterthought in AI governance. 
    
In the SAFE AI™ Framework, Inclusive means ensuring AI does not exclude, misrepresent, or disadvantage the very communities your organisation exists to serve.

### Inclusion Begins With Awareness
AI models learn from patterns in data. If those patterns reflect inequality, bias, or underrepresentation, outputs can reinforce them. For mission-driven organisations, this creates real risk.

### Defining Representation and Access
Inclusion operates at two levels:
1. **Representation:** Are diverse communities portrayed with dignity rather than stereotyped?
2. **Access:** Can all stakeholders meaningfully engage with AI-supported systems regardless of language or ability?

> **Inclusion is not a one-time checkbox. It is a continuous discipline.**`,
    created_at: '2026-03-02T09:00:00Z'
  }
];